import {
    List,
    Datagrid,
    TextField,
    NumberField,
    EditButton,
    Edit,
    SimpleForm,
    TextInput,
    SelectInput,
    required,
    useRecordContext,
    Pagination,
    DateField,
    ReferenceField,
} from 'react-admin';

// Transform function for incoming data (Edit form)
const transformIncoming = (record) => {
    console.log(record);
    if (!record) return null;

    // Extract fields we want to edit
    const {
        id,
        shipping_address,
        shipping_address_id,
        status,
        payment_status,
        tracking_number,
        tracking_url,
        tracking_company,
        notes,
    } = record;

    return {
        id: id,
        shipping_address,
        shipping_address_id,
        status,
        payment_status,
        tracking_number,
        tracking_url,
        tracking_company,
        notes,
    };
};

// Transform function for saving data
const transformOutgoing = (data) => {
    if (!data) return null;

    // Remove any fields that shouldn't be sent to the API
    const {
        id,
        created_at,
        updated_at,
        deleted_at,
        user,
        order_items,
        ...rest
    } = data;

    return rest;
};

const orderStatusChoices = [
    { id: 'pending_payment', name: 'Pending Payment' },
    { id: 'confirmed', name: 'Confirmed' },
    { id: 'shipped', name: 'Shipped' },
    { id: 'delivered', name: 'Delivered' },
    { id: 'cancelled', name: 'Cancelled' },
    { id: 'refunded', name: 'Refunded' },
    { id: 'failed', name: 'Failed' },
];

const paymentStatusChoices = [
    { id: 'pending', name: 'Pending' },
    { id: 'paid', name: 'Paid' },
    { id: 'failed', name: 'Failed' },
    { id: 'refunded', name: 'Refunded' },
    { id: 'cancelled', name: 'Cancelled' },
];

export const OrderList = () => (
    <List 
        pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />}
        perPage={10}
        sort={{ field: 'id', order: 'DESC' }}
    >
        <Datagrid>
            <TextField source="id" />
            <ReferenceField source="user_id" reference="users">
                <TextField source="email" />
            </ReferenceField>
            <TextField source="order_number" />
            <TextField source="status" />
            <NumberField 
                source="total" 
                options={{ style: 'currency', currency: 'IDR' }}
                locales="id-ID"
            />
            <TextField source="payment_status" />
            <DateField source="CreatedAt" showTime={true}/>
            <DateField source="UpdatedAt" showTime={true}/>
            <EditButton />
        </Datagrid>
    </List>
);

const OrderTitle = () => {
    const record = useRecordContext();
    return <span>Order {record ? `#${record.order_number}` : ''}</span>;
};

export const OrderEdit = () => (
    <Edit 
        title={<OrderTitle />} 
        transform={transformOutgoing}
        mutationMode="pessimistic"
    >
        <SimpleForm 
            transform={transformIncoming}
            defaultValues={transformIncoming}
        >
            {/* Read-only fields */}
            <TextInput source="id" label="Order ID" disabled/>
            <TextInput source="order_number" label="Order Number" disabled/>
            <ReferenceField source="user_id" reference="users">
                <TextInput source="email" label="User Email" type="email" disabled/>
            </ReferenceField>
            <TextInput
                type="number"
                source="total" 
                options={{ style: 'currency', currency: 'IDR' }}
                locales="id-ID"
                disabled
            />
            <SelectInput source="shipping_address_id" reference="addresses" disabled/>

            {/* Editable fields */}
            <SelectInput 
                source="status" 
                choices={orderStatusChoices}
                validate={[required()]}
            />
            <SelectInput 
                source="payment_status" 
                choices={paymentStatusChoices}
                validate={[required()]}
            />
            <TextInput source="tracking_number" />
            <TextInput source="tracking_url" />
            <TextInput source="tracking_company" />
            <TextInput 
                source="notes" 
                multiline 
                rows={4}
            />
        </SimpleForm>
    </Edit>
); 